const ROLES = {
    SCHOOL:"SCHOOL",
    TEACHER:"TEACHER",
    STUDENT:"STUDENT",
}

module.exports = ROLES;